import Entity from '../entity'

export default class Branch extends Entity<number>{
    dealer_id: number;
    code: string;
    name: string;
}


